export const AGENT_ONBOARDING_START_PATH = "/onboarding/start/website";

export function getNewProjectOnboardingPath(workspaceId: string) {
  return `${AGENT_ONBOARDING_START_PATH}?${new URLSearchParams({
    entry: "new-project",
    workspaceId,
  }).toString()}`;
}

const agentApplicationPathPrefixes = [
  "/agent",
  "/share/agent",
  "/share/preview",
  "/share/registry",
  "/onboarding/start",
];

const agentApplicationExactPaths = new Set([
  "/cli-auth",
  "/oauth/authorize",
  "/onboarding/agent-billing",
  "/settings/billing",
  "/templates",
]);

export function isAgentApplicationPath(pathname: string) {
  return (
    agentApplicationExactPaths.has(pathname) ||
    agentApplicationPathPrefixes.some((pathPrefix) => {
      return pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`);
    })
  );
}
